import React, { PureComponent } from "react";
import {
  Row,
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Collapse,
  ButtonDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  CustomInput,
  ButtonGroup,
} from "reactstrap";
import { injectIntl } from "react-intl";
import { NotificationManager } from "../../../components/common/react-notifications";
import { Colxx } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../navs/Breadcrumb";
import IntlMessages from "../../../helpers/IntlMessages";
import classnames from "classnames";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import ThumbListIcon from "../../../components/ThumbListIcon";
import DataListIcon from "../../../components/DataListIcon";
import TableImport from "./TableImport";
import ComponentToPrintTems from "../ComponentToPrintTems";
import ReactToPrint from "react-to-print";
import TableImportSuccess from "./TableImportSuccess";
import TableImportFailed from "./TableImportFailed";
import ModalAddProducts from "./ModalAddProducts";
import ModalAddQuantitative from "./ModalAddQuantitative";
import ModalAddProductsFromImage from "./ModalAddProductsFromImage";

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

class PageHeading extends PureComponent {
  constructor(props) {
    super(props);
    // Khôi phục dữ liệu từ sessionStorage (nếu có) khi component mount
    const savedModalData = sessionStorage.getItem("modalProductsData");

    this.state = {
      dropdownSplitOpen: false,
      isOpenModal: false,
      isOpenModalAddProducts: false,
      addProductsFromImage: false,
      addQuantitativeOne: false,
      dataImport: [],
      modalProductsData: savedModalData ? JSON.parse(savedModalData) : null, // Lưu trữ dữ liệu bảng khi modal đóng
    };
    this.componentRef = React.createRef();
  }

  handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet);

        this.setState({ dataImport: jsonData });
      };
      reader.readAsArrayBuffer(file);
    }
  };

  handleDownloadData = () => {
    const fileName = this.props.intl.formatMessage({
      id: "page.heading.export-filename",
      defaultMessage: "Danh sách sản phẩm",
    });

    this.exportToCSV({
      csvData: this.formatDatasExport(this.props.data_all),
      fileName,
    });
  };

  toggleSplit = () => {
    this.setState((prevState) => ({
      dropdownSplitOpen: !prevState.dropdownSplitOpen,
    }));
  };

  toggleDisplayOptions = () => {
    this.setState((prevState) => ({
      displayOptionsIsOpen: !prevState.displayOptionsIsOpen,
    }));
  };

  formatDatasExport = (data) => {
    // console.log('data: ', data)
    let custs = [];

    for (let i = 0, j = data?.length; i < j; i++) {
      custs.push({
        stt: i + 1,
        name: data[i].name,
        sku: data[i].sku,
        barcode: data[i].barcode,
        category: data[i].category.name,
        image: data[i].image,
        bestter: data[i].bestter,
        price: data[i].price,
        price_sale: data[i].price_sale,
        topping: data[i].topping
          ?.map((obj) => `${obj.name}|${obj.value}`)
          .join(", "),
        size: data[i].size?.map((obj) => `${obj.name}|${obj.value}`).join(", "),
        ice: data[i].ice?.map((i) => i).join(", "),
        sugar: data[i].sugar?.map((s) => s).join(", "),
        softHide: data[i].softHide,
        // 'createdAt': data[i].date,
        // 'updatedAt': data[i].updatedAt,
      });
    }
    return custs;
  };

  exportToCSV = ({ csvData, fileName }) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  toggleOpenModal = () => {
    this.setState({
      ...this.state,
      isOpenModal: !this.state.isOpenModal,
      dataImport: [],
    });
  };

  toggleOpenModalAddProducts = (text) => {
    this.setState({
      ...this.state,
      addProductsFromImage: text === "add-products-from-image" ? true : false,
      addQuantitativeOne: text === "add-quantitative-one" ? true : false,
      isOpenModalAddProducts: !this.state.isOpenModalAddProducts,
    });
  };

  // Callback để lưu dữ liệu từ modal khi có thay đổi
  handleModalDataChange = (data) => {
    this.setState({ modalProductsData: data });
    // Lưu vào sessionStorage để giữ khi điều hướng trang
    sessionStorage.setItem("modalProductsData", JSON.stringify(data));
  };

  // Xóa dữ liệu modal (khi cần reset)
  clearModalProductsData = () => {
    this.setState({ modalProductsData: null });
    sessionStorage.removeItem("modalProductsData");
  };

  refreshHandsontable = () => {
    // Kiểm tra xem ref đã tồn tại chưa
    if (
      this.hotTableComponent.current &&
      this.hotTableComponent.current.hotInstance
    ) {
      // Dùng phương thức render() của Handsontable để nó tính toán lại mọi thứ
      this.hotTableComponent.current.hotInstance.render();
    }
  };

  render() {
    const { messages } = this.props.intl;
    const {
      heading,
      hide_button_add,
      setting,
      match,
      data,
      data_all,
      totalItem,
      toggleFunc,
      // isDisabledAdd,
      changePageSizeFunc,
      handleInputChange,
      handleKeyDown,
      displayMode,
      changeDisplayMode,
      handleImportProduct,
      successfulImports,
      failedImports,
      handleChangeSelectAll,
      selectedItemsLength,
      itemsLength,
      onHandlerDelete,
      selectedItems,
      categories,
      data_stocks,
      make_products,
      onSaveRecipe,
      onBulkSoftHide,
      onBulkBestter,
      showExport,
      showAddNew,
      onAddCategory,
      onAddFromTemplate,
    } = this.props;
    const {
      displayOptionsIsOpen,
      dataImport,
      addProductsFromImage,
      addQuantitativeOne,
    } = this.state;
    const data_products = data.filter((item) =>
      selectedItems.includes(item.id),
    );

    // Logic for bulk labels and disabled states
    const selectedIdsSet = new Set(selectedItems.map((id) => String(id)));
    // Combine data and data_all to ensure we find all selected items (including hidden ones)
    const allAvailableData = [...data, ...data_all];
    const uniqueProductsMap = new Map();
    allAvailableData.forEach((p) => {
      if (p && p.id) uniqueProductsMap.set(String(p.id), p);
    });

    const selectedProductsFromAll = selectedItems
      .map((id) => uniqueProductsMap.get(String(id)))
      .filter(Boolean);

    let bulkBestterLabel = this.props.intl.formatMessage({
      id: "page.heading.best_seller",
    });
    let isMixedBestter = false;
    if (selectedItems.length > 0) {
      if (selectedProductsFromAll.length > 0) {
        const allBestter = selectedProductsFromAll.every((p) => !!p.bestter);
        const noneBestter = selectedProductsFromAll.every((p) => !p.bestter);

        if (allBestter) {
          bulkBestterLabel = this.props.intl.formatMessage({
            id: "page.heading.un_best_seller",
          });
        } else if (noneBestter) {
          bulkBestterLabel = this.props.intl.formatMessage({
            id: "page.heading.mark_best_seller",
          });
        } else {
          isMixedBestter = true;
          bulkBestterLabel = this.props.intl.formatMessage({
            id: "page.heading.best_seller",
          });
        }
      }
    }

    let bulkSoftHideLabel = this.props.intl.formatMessage({
      id: "page.heading.soft_hide_mixed",
    });
    let isMixedSoftHide = false;
    if (selectedItems.length > 0) {
      if (selectedProductsFromAll.length > 0) {
        const allSoftHide = selectedProductsFromAll.every((p) => !!p.softHide);
        const noneSoftHide = selectedProductsFromAll.every((p) => !p.softHide);

        if (allSoftHide) {
          bulkSoftHideLabel = this.props.intl.formatMessage({
            id: "page.heading.soft_hide_show",
          });
        } else if (noneSoftHide) {
          bulkSoftHideLabel = this.props.intl.formatMessage({
            id: "page.heading.soft_hide_hide",
          });
        } else {
          isMixedSoftHide = true;
          bulkSoftHideLabel = this.props.intl.formatMessage({
            id: "page.heading.soft_hide_mixed",
          });
        }
      }
    }

    const startIndex = (setting.currentPage - 1) * setting.selectedPageSize;
    const endIndex = setting.currentPage * setting.selectedPageSize;

    return (
      <Row className="list-page-heading__row">
        <Colxx xxs="12">
          <div className="mb-2 product-heading-wrapper">
            <h1>
              <IntlMessages id={heading} />
            </h1>
            <div className="text-zero top-right-button-container mb-3">
              {showAddNew !== false ? (
                <>
                  {/* Nút tải file Excel - đưa ra ngoài */}
                  <Button
                    color="outline-primary"
                    size="md"
                    className="mr-2 excel-export-pages top-right-button"
                    onClick={this.handleDownloadData}
                  >
                    <i className="simple-icon-cloud-download mr-2" />
                    <span className="d-none d-md-inline">
                      <IntlMessages id="page.heading.excel" />
                    </span>
                  </Button>

                  {onAddFromTemplate && (
                    <Button
                      color="outline-secondary"
                      size="md"
                      className="mr-2 top-right-button"
                      onClick={onAddFromTemplate}
                    >
                      <i className="simple-icon-list mr-2" />
                      <span>Nhập từ mẫu</span>
                    </Button>
                  )}

                  <ButtonDropdown
                    isOpen={this.state.dropdownSplitOpen}
                    toggle={this.toggleSplit}
                    className="mr-2"
                  >
                    <Button
                      color="primary"
                      size="md"
                      className={classnames(
                        "top-right-button position-relative tour-button-add",
                        {
                          disable: hide_button_add,
                        },
                      )}
                      onClick={() => {
                        if (hide_button_add) {
                          NotificationManager.error(
                            this.props.intl.formatMessage({
                              id: "page.heading.error.limit",
                            }),
                            this.props.intl.formatMessage({
                              id: "page.heading.error.limit_title",
                            }),
                            3000,
                            null,
                            null,
                            "",
                          );
                        } else {
                          toggleFunc();
                        }
                      }}
                    >
                      <IntlMessages id="pages.add-new" />
                      {hide_button_add ? (
                        <i className="simple-icon-diamond diamond-upgrade-add" />
                      ) : null}
                    </Button>
                    <div className="btn btn-primary btn-lg pl-4 pr-0 check-button check-all">
                      <CustomInput
                        className="custom-checkbox mb-0 d-inline-block"
                        type="checkbox"
                        id="checkAll"
                        checked={selectedItemsLength >= itemsLength}
                        onChange={() => handleChangeSelectAll(true)}
                        onClick={
                          displayMode !== "thumblist"
                            ? () => changeDisplayMode("thumblist")
                            : null
                        }
                        label={
                          <span
                            className={`custom-control-label ${
                              selectedItemsLength > 0 &&
                              selectedItemsLength < itemsLength
                                ? "indeterminate"
                                : ""
                            }`}
                          />
                        }
                      />
                    </div>
                    <DropdownToggle caret color="primary" />
                    <DropdownMenu>
                      <DropdownItem
                        onClick={() => {
                          const item = data.find(
                            (d) => String(d.id) === String(selectedItems[0]),
                          );
                          if (item) this.props.onHandlerEditProduct(item);
                        }}
                        className={classnames(
                          "d-flex align-items-center d-block d-md-none",
                          {
                            disable: selectedItems.length !== 1,
                          },
                        )}
                        disabled={selectedItems.length !== 1}
                      >
                        <i className="simple-icon-pencil pr-2" />
                        Cập nhật sản phẩm
                      </DropdownItem>
                      <DropdownItem divider className="d-block d-md-none" />
                      <DropdownItem
                        onClick={() =>
                          this.toggleOpenModalAddProducts(
                            "add-quantitative-one",
                          )
                        }
                        className={classnames("d-flex align-items-center", {
                          disable: selectedItems.length === 0,
                        })}
                        disabled={selectedItems.length === 0}
                      >
                        <i className="simple-icon-check pr-2" />
                        <IntlMessages id="page.heading.create_quantitative" />
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem
                        onClick={onBulkBestter}
                        className={classnames("d-flex align-items-center", {
                          disable: selectedItems.length === 0 || isMixedBestter,
                        })}
                        disabled={selectedItems.length === 0 || isMixedBestter}
                        style={
                          isMixedBestter
                            ? {
                                cursor: "not-allowed",
                              }
                            : {}
                        }
                      >
                        <i className="simple-icon-star pr-2" />
                        {bulkBestterLabel}
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem
                        onClick={onBulkSoftHide}
                        className={classnames("d-flex align-items-center", {
                          disable:
                            selectedItems.length === 0 || isMixedSoftHide,
                        })}
                        disabled={selectedItems.length === 0 || isMixedSoftHide}
                        style={
                          isMixedSoftHide
                            ? {
                                cursor: "not-allowed",
                              }
                            : {}
                        }
                      >
                        <i className="simple-icon-lock pr-2" />
                        {bulkSoftHideLabel}
                      </DropdownItem>
                      <DropdownItem divider />
                      {this.componentRef && (
                        <ReactToPrint
                          trigger={() => (
                            <DropdownItem
                              className={classnames(
                                "d-flex align-items-center",
                                {
                                  disable: selectedItems.length === 0,
                                },
                              )}
                              disabled={selectedItems.length === 0}
                            >
                              <i className="simple-icon-printer pr-2" />
                              <IntlMessages id="page.heading.print_sticker" />
                            </DropdownItem>
                          )}
                          content={() => this.componentRef}
                        />
                      )}
                      <DropdownItem divider />
                      <DropdownItem
                        className={classnames("text-left red", {
                          disable: selectedItemsLength === 0,
                        })}
                        onClick={onHandlerDelete}
                        disabled={selectedItemsLength === 0}
                      >
                        <>
                          <i className="simple-icon-trash pr-2" />
                          <IntlMessages id="pages.delete" />
                        </>
                      </DropdownItem>
                    </DropdownMenu>
                  </ButtonDropdown>
                </>
              ) : (
                /* Category tab - show Add Category button */
                <Button
                  color="primary"
                  size="md"
                  className="top-right-button"
                  onClick={onAddCategory}
                >
                  <i className="simple-icon-plus mr-1" />
                  <IntlMessages id="category.add-new-category" />
                </Button>
              )}
            </div>
            <Breadcrumb match={match} />
          </div>

          <div className="mb-2">
            <Button
              color="empty"
              className="pt-0 pl-0 d-inline-block d-md-none"
              onClick={this.toggleDisplayOptions}
            >
              <IntlMessages id="pages.display-options" />{" "}
              <i className="simple-icon-arrow-down align-middle" />
            </Button>
            <Collapse
              isOpen={displayOptionsIsOpen}
              className="d-md-block"
              id="displayOptions"
            >
              <span className=" d-none d-md-flex mr-3 d-inline-block float-md-left ">
                <a
                  href="#/"
                  className={`mr-2 view-icon ${
                    displayMode === "thumblist" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    changeDisplayMode("thumblist");
                  }}
                >
                  <ThumbListIcon />
                </a>
                <a
                  href="#/"
                  className={`mr-2 view-icon ${
                    displayMode === "list" ? "active" : ""
                  }`}
                  onClick={(e) => {
                    e.preventDefault();
                    changeDisplayMode("list");
                  }}
                >
                  <DataListIcon />
                </a>
              </span>
              {!this.props.hideSearch && (
                <div className="d-block d-md-inline-block">
                  <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                    <input
                      type="text"
                      name="keyword"
                      id="search"
                      placeholder={messages["product.search"]}
                      onChange={handleInputChange}
                      onKeyDown={handleKeyDown}
                    />
                  </div>
                </div>
              )}
              {displayMode === "list" ? null : (
                <div className="float-md-right">
                  <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${totalItem} `}</span>
                  <UncontrolledDropdown className="d-inline-block">
                    <DropdownToggle caret color="outline-dark" size="xs">
                      {setting.selectedPageSize}
                    </DropdownToggle>
                    <DropdownMenu right>
                      {setting.pageSizes.map((size, index) => {
                        return (
                          <DropdownItem
                            key={index}
                            onClick={() => changePageSizeFunc(size)}
                          >
                            {size}
                          </DropdownItem>
                        );
                      })}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              )}
            </Collapse>
          </div>
          {/* <Separator /> */}
        </Colxx>
        <Modal
          isOpen={this.state.isOpenModalAddProducts}
          // toggle={this.toggleOpenModalAddProducts}
          className={classnames("table-modal cursor-pointer")}
          modalClassName="table-modal-dialog-wrapper"
          contentClassName="table-modal-content-wrapper"
          // onAfterOpen={this.refreshHandsontable}
        >
          <ModalHeader toggle={this.toggleOpenModalAddProducts}>
            {addProductsFromImage ? (
              <IntlMessages id="page.heading.add_from_image" />
            ) : addQuantitativeOne ? (
              <IntlMessages id="page.heading.create_quantitative" />
            ) : (
              <IntlMessages id="page.heading.add_bulk" />
            )}
          </ModalHeader>
          <ModalBody>
            {addProductsFromImage ? (
              <ModalAddProductsFromImage />
            ) : addQuantitativeOne ? (
              <ModalAddQuantitative
                onSaveRecipe={onSaveRecipe}
                data_products={data_products}
                data_stocks={data_stocks}
                make_products={make_products}
                toggleOpenModalAddProducts={this.toggleOpenModalAddProducts}
              />
            ) : (
              <ModalAddProducts
                handleImportProduct={handleImportProduct}
                data_all={data_all}
                categories={categories}
                savedData={this.state.modalProductsData}
                onDataChange={this.handleModalDataChange}
              />
            )}
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.isOpenModal}
          // toggle={this.toggleOpenModal}
          className={classnames("table-modal cursor-pointer max-width-100")}
        >
          <ModalHeader toggle={this.toggleOpenModal}>
            <IntlMessages id="page.heading.import_excel_title" />
          </ModalHeader>
          <ModalBody className={"d-flex modal-body-import"}>
            {/* <PerfectScrollbar
                            options={{
                                suppressScrollX: true,
                                wheelPropagation: false,
                            }}
                        > */}

            {successfulImports?.length || failedImports?.length ? (
              <div className="d-flex flex-column mb-3 w-100">
                <h3>
                  <IntlMessages id="page.heading.import_result" />
                </h3>
                {successfulImports.length > 0 ? (
                  <TableImportSuccess
                    data={successfulImports}
                    dataFailed={failedImports}
                  />
                ) : null}
                {failedImports.length > 0 ? (
                  <TableImportFailed
                    data={failedImports}
                    dataSuccess={successfulImports}
                    isFailedTable={true}
                  />
                ) : null}
              </div>
            ) : dataImport.length ? (
              <div className="d-flex flex-column mb-3 w-100">
                <TableImport data={dataImport} failedImport={failedImports} />
              </div>
            ) : (
              <input
                type="file"
                accept=".xlsx, .xls"
                onChange={this.handleFileUpload}
              />
            )}
            {/* </PerfectScrollbar> */}
          </ModalBody>
          <ModalFooter className={"d-flex justify-content-center"}>
            <Button
              color="primary"
              onClick={() => handleImportProduct(dataImport)}
            >
              <IntlMessages id="page.heading.import_btn" />
            </Button>
          </ModalFooter>
        </Modal>
        <div style={{ display: "none" }}>
          {data_all.length ? (
            <ComponentToPrintTems
              selectedItems={selectedItems}
              items={data_all}
              ref={(el) => (this.componentRef = el)}
            />
          ) : null}
        </div>
      </Row>
    );
  }
}

export default injectIntl(PageHeading);
